if (!customElements.get('product-recs-carousel')) {
  class ProductRecsCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-prc-track]');
      this.prevBtn = this.querySelector('[data-prc-prev]');
      this.nextBtn = this.querySelector('[data-prc-next]');
    }

    connectedCallback() {
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onAddToCart = this.onAddToCart.bind(this);
      this.updateArrowState = this.updateArrowState.bind(this);

      this.querySelectorAll('[data-prc-variant-select]').forEach((select) => {
        select.addEventListener('change', this.onVariantChange);
      });

      this.querySelectorAll('[data-prc-add-to-cart]').forEach((btn) => {
        btn.addEventListener('click', this.onAddToCart);
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByCard(1));

      if (this.track) {
        this.track.addEventListener('scroll', this.debounce(this.updateArrowState, 100), { passive: true });
        window.addEventListener('resize', this.debounce(this.updateArrowState, 150));
        this.updateArrowState();
      }
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    scrollByCard(direction) {
      const item = this.track.querySelector('[data-prc-item]');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
      const distance = (item.getBoundingClientRect().width + gap) * direction;
      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    updateArrowState() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      this.prevBtn.disabled = this.track.scrollLeft <= 0;
      this.nextBtn.disabled = this.track.scrollLeft >= maxScroll;
    }

    onVariantChange(event) {
      const select = event.target;
      const option = select.selectedOptions[0];
      const item = select.closest('[data-prc-item]');
      if (!item || !option) return;

      const priceEl = item.querySelector('[data-prc-price]');
      const imageEl = item.querySelector('[data-prc-image]');
      const addBtn = item.querySelector('[data-prc-add-to-cart]');

      if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;
      if (imageEl && option.dataset.image) imageEl.src = option.dataset.image;

      const available = option.dataset.available === 'true';
      if (addBtn) {
        addBtn.dataset.variantId = option.value;
        addBtn.disabled = !available;
        addBtn.classList.toggle('product-recs__atc-btn--disabled', !available);
        const label = addBtn.querySelector('[data-prc-btn-text]');
        if (label) label.textContent = available ? 'Add To Cart' : 'Sold out';
      }
    }

    async onAddToCart(event) {
      const btn = event.currentTarget;
      if (btn.disabled || btn.classList.contains('is-loading')) return;

      const item = btn.closest('[data-prc-item]');
      const singleVariantInput = item?.querySelector('[data-prc-single-variant-id]');
      const variantId = btn.dataset.variantId || singleVariantInput?.value;
      if (!variantId) return;

      btn.classList.add('is-loading');
      btn.disabled = true;
      const spinner = btn.querySelector('[data-prc-spinner]');
      if (spinner) spinner.hidden = false;

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || 'Could not add product to cart');
        }

        await this.refreshCartUI();
        this.dispatchEvent(
          new CustomEvent('product-recs:added', { bubbles: true, detail: { variantId } })
        );
      } catch (error) {
        console.error('[product-recs-carousel] add to cart failed:', error);
      } finally {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (spinner) spinner.hidden = true;
      }
    }

    async refreshCartUI() {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const res = await fetch(`${root}?sections=cart-icon-bubble`);
        if (res.ok) {
          const data = await res.json();
          const html = data['cart-icon-bubble'];
          const bubble = document.getElementById('cart-icon-bubble');
          if (html && bubble) {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const newBubble = parsed.getElementById('cart-icon-bubble');
            if (newBubble) bubble.innerHTML = newBubble.innerHTML;
          }
        }
      } catch (e) {
        // Non-fatal: cart bubble just won't refresh, item is still added.
      }

    
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const res = await fetch(`${root}?sections=cart-drawer`);
          if (res.ok) {
            const data = await res.json();
            const html = data['cart-drawer'];
            if (html) {
              const parsed = new DOMParser().parseFromString(html, 'text/html');
              const newDrawer = parsed.querySelector('cart-drawer');
              if (newDrawer) cartDrawer.innerHTML = newDrawer.innerHTML;
            }
          }
          cartDrawer.open();
        } catch (e) {
          // Fall through silently; item is already in the cart.
        }
      }
    }
  }

  customElements.define('product-recs-carousel', ProductRecsCarousel);
}
